"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appManifestSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const initialState = {};
exports.appManifestSlice = (0, toolkit_1.createSlice)({
    name: 'appManifest',
    initialState,
    reducers: {
        setAppManifest: (state, action) => {
            state.appManifest = {
                status: 'done',
                error: undefined,
                data: action.payload,
            };
        },
        updateAppManifest: (state, action) => {
            var _a, _b;
            if (((_a = state.appManifest) === null || _a === void 0 ? void 0 : _a.status) === 'done') {
                if (!(0, lodash_isequal_1.default)((_b = state.appManifest) === null || _b === void 0 ? void 0 : _b.data, action.payload)) {
                    state.appManifest.data = action.payload;
                }
            }
            else {
                state.appManifest = {
                    status: 'done',
                    error: undefined,
                    data: action.payload,
                };
            }
        },
        setLoading: (state) => {
            state.appManifest = {
                status: 'loading',
                error: undefined,
                data: undefined,
            };
        },
        setError: (state, action) => {
            state.appManifest = {
                status: 'error',
                error: action.payload,
                data: undefined,
            };
        },
    },
});
